'use client';

import { __assign } from '../../../_virtual/_tslib.js';
import { deepCloneArray, getChildrenListByParentId } from '../../../TreeSelect/helpers.js';

var setTemporaryValue = function (state, action) {
    var _a, _b;
    var temporaryValue = deepCloneArray(state.temporaryValue);
    var formattedPayload = action.payload;
    var _c = formattedPayload.parentId, parentId = _c === void 0 ? -1 : _c, _d = formattedPayload.childrenId, childrenId = _d === void 0 ? -1 : _d, children = formattedPayload.children;
    // 0. No parent
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredParents.length === 0) {
        // Dont have parent
        // Easy case push all to temporaryValue
        var updateChildrenIds = [childrenId];
        // Check if parent have only 1 children or not
        var childrenList_1 = getChildrenListByParentId(parentId.toString(), children);
        if (childrenList_1.length === 1) {
            updateChildrenIds = [-1];
        }
        temporaryValue.push({
            parentId: parentId,
            childrenIds: updateChildrenIds
        });
        return __assign(__assign({}, state), { temporaryValue: temporaryValue });
    }
    var selectedChildrenIds = filteredParents[0].childrenIds;
    // HAVE PARENT
    // 1. REMOVE parent when user select '-1' again
    if (selectedChildrenIds.includes(-1) && childrenId === -1) {
        temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        return __assign(__assign({}, state), { temporaryValue: temporaryValue });
    }
    // Select another item
    var filteredChildrenId = selectedChildrenIds.filter(function (item) { return item === childrenId; });
    var parentIndex = temporaryValue.findIndex(function (item) { return item.parentId === parentId; });
    // 2. Have children ids already but user select '-1'
    if (!selectedChildrenIds.includes(-1) && childrenId === -1) {
        // set to all
        temporaryValue[parentIndex].childrenIds = [-1];
        return __assign(__assign({}, state), { temporaryValue: temporaryValue });
    }
    // 3. Already exist then remove it
    if (filteredChildrenId.length > 0) {
        temporaryValue[parentIndex].childrenIds = temporaryValue[parentIndex].childrenIds.filter(function (item) { return item !== childrenId; });
        // 3.1 Remove parent out of array when there is no children remain
        if (temporaryValue[parentIndex].childrenIds.length === 0) {
            temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        }
        return __assign(__assign({}, state), { temporaryValue: temporaryValue });
    }
    // 4. From all item (-1) to remain item
    if (selectedChildrenIds.length === 1 && selectedChildrenIds[0] === -1 && childrenId !== -1) {
        var childrenList_2 = getChildrenListByParentId(parentId.toString(), children);
        var filteredOutItem = childrenList_2.filter(function (item) { return item.id !== childrenId; });
        var selectedItems = filteredOutItem.map(function (item) { return item.id; });
        temporaryValue[parentIndex].childrenIds = selectedItems;
        // 4.1 Remove parent out of array when there is no children remain
        if (selectedItems.length === 0) {
            // No more item remains in parent then remove parent too
            temporaryValue = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
        }
        return __assign(__assign({}, state), { temporaryValue: temporaryValue });
    }
    // 5. Doesn't exist then add it
    temporaryValue[parentIndex].childrenIds.push(childrenId);
    // 5.1 Check max then set back to all
    var currentCountItem = (_b = (_a = temporaryValue[parentIndex]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length;
    var childrenList = getChildrenListByParentId(parentId.toString(), children);
    if (childrenList.length === currentCountItem) {
        temporaryValue[parentIndex].childrenIds = [-1];
    }
    return __assign(__assign({}, state), { temporaryValue: temporaryValue });
};
var removeParentId = function (state, parentId) {
    var temporaryValue = state.temporaryValue;
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId !== parentId; });
    return __assign(__assign({}, state), { temporaryValue: filteredParents, value: filteredParents });
};

export { removeParentId, setTemporaryValue };
//# sourceMappingURL=selectReducer.js.map
